import {
  getFactoringStatusChipType,
  getStatusChipColor,
} from 'lib/mobileDesignSystem';
import React, { createContext, useCallback, useContext, useState } from 'react';

export interface FactoringOperationDetailContextValue {
  status: string | null;
  setOperationStatus: (status: string | null) => void;
  quoteId: number | null;
  setQuoteId: (id: number | null) => void;
  requestId: string | null;
  setRequestId: (id: string | null) => void;
}

const FactoringOperationDetailContext =
  createContext<FactoringOperationDetailContextValue | null>(null);

export const useFactoringOperationDetail =
  (): FactoringOperationDetailContextValue => {
    const ctx = useContext(FactoringOperationDetailContext);
    if (ctx == null) {
      throw new Error(
        'useFactoringOperationDetail must be used within FactoringOperationDetailProvider',
      );
    }
    return ctx;
  };

export const getFactoringStatusColor = (status: string): string => {
  const type = getFactoringStatusChipType(status);
  return getStatusChipColor(type);
};

export const FactoringOperationDetailProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [status, setOperationStatus] = useState<string | null>(null);
  const [quoteId, setQuoteId] = useState<number | null>(null);
  const [requestId, setRequestId] = useState<string | null>(null);
  const value: FactoringOperationDetailContextValue = {
    status,
    setOperationStatus: useCallback((s) => setOperationStatus(s), []),
    quoteId,
    setQuoteId: useCallback((id) => setQuoteId(id), []),
    requestId,
    setRequestId: useCallback((id) => setRequestId(id), []),
  };
  return (
    <FactoringOperationDetailContext.Provider value={value}>
      {children}
    </FactoringOperationDetailContext.Provider>
  );
};
